import i18next from 'i18next';

/** 훅 밖 문구 번역 — 저장되는 제목·본문은 작성 시점 언어로 남음 */
export const localize = (
  key: string,
  values?: Record<string, unknown>,
): string => {
  const out = i18next.t(key, {
    ...values,
    interpolation: { escapeValue: false },
  });
  return typeof out === 'string' && out
    ? out
    : key.replace(/\{\{(\w+)\}\}/g, (_, k) => String(values?.[k] ?? ''));
};
